<template>
  <li class="nav__nav-item" role="menuitem">
    <component
      :is="linkType(tag)"
      :href="url"
      :class="['nav__nav-link', { active: currentUrl == url }]">
      <slot>Link Name</slot>
    </component>
  </li>
</template>

<script>
import { Link } from "@inertiajs/vue3";

export default {
  components: {
    Link,
  },

  props: {
    url: {
      type: String,
      required: true,
    },
    currentUrl: {
      type: String,
      required: false,
      default: false,
    },
    tag: {
      type: String,
      default: "",
    },
  },

  setup() {
    const linkType = (tag) => {
      return tag === "external" ? "a" : "Link";
    };

    return {
      linkType,
    };
  },
};
</script>
